import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { grey } from "@mui/material/colors";

interface BusinessTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const businessTypes = [
  { label: "Laundry", value: "Laundry" },
  { label: "Restaurant", value: "Restaurant" },
  { label: "Car wash", value: "Carwash" },
  { label: "Vehicle retailer", value: "Vehicle retailer" },
  { label: "Saloon", value: "Saloon" },
  { label: "Grocery", value: "Grocery" },
];

export const BusinessTypeSelect: React.FC<BusinessTypeSelectProps> = ({ value, onChange }) => {
  return (
    <FormControl fullWidth variant="standard" sx={{ m: 2, marginTop: "12px" }}>
      <InputLabel id="business-type-label" style={{ display: "flex", alignItems: "center" }}>
        <AddBusinessIcon sx={{ color: grey[600] }} />
        <span style={{ marginLeft: "6px" }}>Business Type</span>
        <span style={{ color: "#f04141", fontSize: "18px", marginLeft: "2px" }}>*</span>
      </InputLabel>
      <Select labelId="business-type-label" value={value} onChange={(e) => onChange(e.target.value)}>
        {businessTypes.map((type) => (
          <MenuItem key={type.value} value={type.value}>
            {type.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
